import React, { useState, useEffect } from 'react';
import ApexCharts from 'react-apexcharts';
import Button from 'react-bootstrap/Button';
import Cookies from 'js-cookie';

// Datatables imports
import DataTablesCore from 'datatables.net-bs5';
import DataTable from 'datatables.net-react';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-responsive-bs5';

import introJs from 'intro.js';

import { columnsTopOnHand, columnsLowStock, columnsTopOutOfStock, columnsTopPopularItems, } from './reportsSampleData';
//import { sampleTopOnHand, sampleTopOutOfStock, sampleLowStock, sampleTopPopularItems, headingStatistics } from './reportsSampleData';

import {
  sampleTopOnHand,
  sampleTopOutOfStock,
  sampleLowStock,
  sampleTopPopularItems,
  sampleCategoryQOH,
  sampleDailyDistributedQuantity,
  sampleDailyDistributedValue,
  headingStatistics
} from './reportsFakeData';

import { ExportTransactionsModal } from '../modals/FP_ExportTransactionsModal';


function Reports({ contentOpen, setContentOpen, userPermissions }) {
  // Modified StatCard component
  const StatCard = ({ title, value, unit = '', className = '' }) => { // 👈 Accept className prop
    const cardStyle = {
      // Removed fixed width earlier
      height: "100px",
      backgroundColor: "white",
      borderRadius: "10px",
      padding: "16px",
      color: "black",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #ced4da",
    };
    return (
      // Apply the className prop here
      <div className={className} style={cardStyle}>
        <div style={{ fontSize: "16px", fontWeight: "bold", textAlign: "center" }}>{title}</div>
        <div style={{ fontSize: "16px", fontWeight: "normal" }}>{value}{unit}</div>
      </div>
    );
  };
  //
  // Modified StatCard component for Apex Charts
  const ChartCard = ({ title, value, unit = '', className = '', children }) => {
    const cardStyle = {
      // Removed fixed width earlier
      height: "100px",
      backgroundColor: "white",
      borderRadius: "10px",
      padding: "16px",
      color: "black",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #ced4da",
    };
    return (
      // Apply the className prop here
      <div className={className} style={{ ...cardStyle, height: 'auto', justifyContent: 'flex-start' }}>
        {children} {/* 3. RENDER THE CHILDREN */}
      </div>
    );
  };

  const stockColumns = [
    { title: 'Item Name', data: 'item_name' },
    { title: 'QOH', data: 'current_qty' },
  ];

  const outOfStockColumns = [
    { title: 'Item Name', data: 'item_name', width: '25%' },
    { title: 'Last Transaction', data: 'last_transaction' }
  ];

  const lowStockColumns = [
    { title: 'Item Name', data: 'item_name' },
    { title: 'QOH', data: 'current_qty' },
    { title: 'Days Left', data: 'projected_operation_days_left' },
    { title: 'Run-Out Date', data: 'projected_continuous_operation_run_out_date' }
  ];

  const popularItemsColumns = [
    { title: 'Item Name', data: 'item_name' },
    { title: 'Units Distributed', data: 'total_sold' },
  ];

  const [organization, setOrganization] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [selectedOrgID, setSelectedOrgID] = useState("");
  const [showOrgSelector, setShowOrgSelector] = useState(true);
  const [LoadingPDF, setLoadingPDF] = useState(false);
  const [showExportTransactionsModal, setShowExportTransactionsModal] = useState(false);

  useEffect(() => {
    // 1. Fetch the cookie value. Assuming 'Cookies.get' returns the raw, encoded value.
    let cookieOrgID = Cookies.get('OrgID');

    // 2. Add URL decoding here to handle %3A, %5B, %22, etc.
    if (cookieOrgID) {
      cookieOrgID = decodeURIComponent(cookieOrgID);
    }

    if (cookieOrgID && cookieOrgID.startsWith('j:')) {
      try {
        const orgArr = JSON.parse(cookieOrgID.slice(2));
        if (Array.isArray(orgArr) && orgArr.length > 0 && orgArr[0].orgID) {
          cookieOrgID = orgArr[0].orgID;
        } else {
          cookieOrgID = null;
        }
      } catch (err) {
        console.error("Error parsing OrgID cookie:", err);
        cookieOrgID = null;
      }
    }
    if (cookieOrgID) {
      setSelectedOrgID(cookieOrgID);
      setShowOrgSelector(false);
      if (organization && organization.length > 0) {
        const matchedOrg = organization.find(org => org.orgID === cookieOrgID);
        if (matchedOrg) {
          setSelectedOrg(matchedOrg.name);
        }
      }
    } else {
      setShowOrgSelector(true);
    }
  }, [organization]);

  const url = process.env.REACT_APP_BACKURL;

  const [clientId, setClientId] = useState('client1');
  const [numResults, setNumResults] = useState(10);

  const getLocalISODate = (dayOffset = 0) => {
    const d = new Date();
    d.setDate(d.getDate() + dayOffset);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [startDate, setStartDate] = useState(getLocalISODate(0));
  const [endDate, setEndDate] = useState(getLocalISODate(1));

  const handleSelectedOrgID = (orgName) => {
    const matchedOrg = organization.find(org => org.name === orgName);
    if (matchedOrg) {
      setSelectedOrgID(matchedOrg.orgID);
    } else {
      setSelectedOrgID(null);
      console.error("Organization ID not found for the selected organization.");
    }
  };

  const handleOrgChange = (e) => {
    const selectedName = e.target.value;
    if (selectedName === "Sample Reports Page") {
      setSelectedOrg("Sample Reports Page");
      setSelectedOrgID("Sample Reports Page");
    } else {
      setSelectedOrg(selectedName);
      handleSelectedOrgID(selectedName);
    }
  };

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const url = process.env.REACT_APP_BACKURL;
        if (!url) {
          throw new Error("REACT_APP_BACKURL is not defined");
        }
        const orgResponse = await fetch(url + '/api/foodPantry/organization', {
          credentials: 'include',
        });
        if (!orgResponse.ok) {
          throw new Error(`Organization error! Status: ${orgResponse.status}`);
        }
        const orgData = await orgResponse.json();
        if (orgData?.OrgNames?.length) {
          setOrganization(orgData.OrgNames);
        }
      } catch (error) {
        console.error('Error fetching report data:', error);
      }
    };
    fetchOrganizations();
  }, []);

  const [topQOHItems, setTopQOHItems] = useState([]);
  const [outOfStockItems, setOutOfStockItems] = useState([]);
  const [lowStockItems, setLowStockItems] = useState([]);
  const [categoryQOH, setCategoryQOH] = useState([]);

  const [topTenPopularItems, setTopTenPopularItems] = useState([]);
  const [totalUnitsDistributed, setTotalUnitsDistributed] = useState(0);
  const [totalDistributedValue, setTotalDistributedValue] = useState(0);
  const [dailyDistributedQuantity, setDailyDistributedQuantity] = useState([]);
  const [dailyDistributedValue, setDailyDistributedValue] = useState([]);

  const [numItemsDistributedPerCategory, setNumItemsDistributedPerCategory] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Logic to transform flat data into ApexCharts format
  const distributedByCategoryData = numItemsDistributedPerCategory.reduce((acc, curr) => {
    acc.categories.push(curr.categoryName);
    acc.seriesData.push(curr.totalItemsDistributed);
    return acc;
  }, { categories: [], seriesData: [] });

  const categoryChartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false }
    },
    title: {
      text: `Items Distributed by Category (${startDate.replace(/-/g, '/')} - ${endDate.replace(/-/g, '/')})`,
      align: 'left'
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '80%',
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${new Intl.NumberFormat().format(val)} items`
    },
    xaxis: {
      categories: distributedByCategoryData.categories,
      title: {
        text: 'Total Distributed Items'
      },
      labels: {
        formatter: (val) => new Intl.NumberFormat().format(val)
      }
    },
    yaxis: {
      title: {
        text: 'Item Category'
      }
    },
    tooltip: {
      y: {
        formatter: (val) => `${new Intl.NumberFormat().format(val)} items`
      }
    },
    colors: ['#008FFB'],
  };

  const categoryChartSeries = [{
    name: 'Items Distributed',
    data: distributedByCategoryData.seriesData,
  }];

  const cardShadowStyle = {
    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
  };

  useEffect(() => {
    const fetchImmediateKpis = async () => {
      // Run immediately since orgID is hardcoded (but still check if it's truthy if possible)
      if (!selectedOrgID) return;

      setLoading(true);
      setError(null);
      try {
        const url = process.env.REACT_APP_BACKURL;
        if (!url) {
          throw new Error("REACT_APP_BACKURL is not defined");
        }

        // Fetching data using the hardcoded orgID
        const response = await fetch(`${url}/api/foodPantry/reports/${selectedOrgID}/immediate-kpis?timezoneOffset=${-(new Date().getTimezoneOffset())}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: "include"
        });

        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }

        const data = await response.json();

        //console.log("Immediate KPIs data:", data);
        // Setting all three data arrays from the API response
        setTopQOHItems(data.topTenQOHItems || []);
        setOutOfStockItems(data.outOfStockItems || []);
        setLowStockItems(data.lowStockItems || []);
        // Backend returns this key as `categoriesQOH`; keep fallback for older payloads.
        setCategoryQOH(data.categoriesQOH || data.categoryQOH || []);

      } catch (err) {
        console.error('Error fetching immediate KPIs:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (selectedOrgID === "Sample Reports Page") {
      // Set sample data instead of calling API
      setTopQOHItems(sampleTopOnHand);
      setOutOfStockItems(sampleTopOutOfStock);
      setLowStockItems(sampleLowStock);
      setCategoryQOH(sampleCategoryQOH);
    } else {
      fetchImmediateKpis();
    }

    // Dependency uses the hardcoded orgID as requested
  }, [selectedOrgID]);

  useEffect(() => {
    // Prevent fetch if orgID or date range is missing
    if (!selectedOrgID || !startDate || !endDate) return;

    const fetchDateFilteredKpis = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = process.env.REACT_APP_BACKURL;
        if (!url) {
          throw new Error("REACT_APP_BACKURL is not defined");
        }

        // Fetching data using orgID, startDate, and endDate
        const response = await fetch(
          `${url}/api/foodPantry/reports/${selectedOrgID}/date-kpis?startDate=${startDate}&endDate=${endDate}&timezoneOffset=${-(new Date().getTimezoneOffset())}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: "include"
          }
        );

        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }

        const data = await response.json();

        //console.log("Date-filtered KPIs data:", data);

        // Setting the three data results from the API response
        setTopTenPopularItems(data.topTenPopularItems || []);
        setTotalUnitsDistributed(data.totalUnitsDistributed || 0);
        setTotalDistributedValue(data.totalDistributedValue || 0);
        setDailyDistributedQuantity(data.dailyDistributedQuantity || []);
        setDailyDistributedValue(data.dailyDistributedValue || []);

      } catch (err) {
        console.error('Error fetching date-filtered KPIs:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (selectedOrgID === "Sample Reports Page") {
      // Set sample data instead of calling API
      setTopTenPopularItems(sampleTopPopularItems);
      setTotalUnitsDistributed(sampleDailyDistributedQuantity.reduce((sum, d) => sum + d.total_quantity, 0));
      setTotalDistributedValue(sampleDailyDistributedValue.reduce((sum, d) => sum + d.daily_distributed_value, 0));
      setDailyDistributedQuantity(sampleDailyDistributedQuantity);
      setDailyDistributedValue(sampleDailyDistributedValue);
      setNumItemsDistributedPerCategory(
        headingStatistics.map(stat => ({
          categoryName: stat.label,
          totalItemsDistributed: stat.value
        }))
      );
    }
    else {
      fetchDateFilteredKpis();
    }
    // Dependencies now include the hardcoded orgID and the date range state variables
  }, [selectedOrgID, startDate, endDate]);


  function formatDate(dateStr) {
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    // Format as MM/DD/YYYY
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
  }

  // Tour state
  const [tourStage, setTourStage] = useState("none");
  const [isTourRunning, setIsTourRunning] = useState(false);
  const [manualTour, setManualTour] = useState(false);
  const [tourRanOnce, setTourRanOnce] = useState(false);

  // Tour steps: Title then Export PDF button
  const mainTourSteps = [
    {
      element: ".reports-title",
      intro: "This is the Organization Reports page. Here you can view and export reports.",
      position: "bottom"
    },
    {
      element: ".export-pdf-btn",
      intro: "Click here to export the current report as a PDF.",
      position: "left"
    }
  ];

  // Helper to check if a tour is running
  function isIntroJsActive() {
    const introInstance = window.introJs && window.introJs();
    const overlay = document.querySelector('.introjs-overlay');
    return (introInstance && introInstance._currentStep !== undefined) || (overlay && overlay.style.display !== 'none');
  }

  // Main tour effect
  useEffect(() => {
    if (tourStage === "main" && !isTourRunning && !isIntroJsActive()) {
      setIsTourRunning(true);
      setTimeout(() => {
        const intro = introJs();
        intro.setOptions({
          steps: mainTourSteps,
          showBullets: false
        });
        intro.start();
        intro.oncomplete(() => {
          setIsTourRunning(false);
          setTourStage("none");
          handleTourRedirect();
        });
        intro.onexit(() => {
          setIsTourRunning(false);
          setTourStage("none");
          if (manualTour) {
            setManualTour(false);
          }
        });
      }, 300); // 300ms delay before starting tour
    }
  }, [tourStage, isTourRunning]);

  // Redirection logic after tour
  function handleTourRedirect() {
    if (manualTour) {
      setManualTour(false);
      return;
    }
    setContentOpen("searchOrganizations");
  }

  // Automatic tour trigger (continuously re-prompt tour start logic)
  useEffect(() => {
    if (!userPermissions) return;
    const fullTourNeeded = JSON.parse(localStorage.getItem("FullTourNeeded"));
    if (!fullTourNeeded) return;

    if (tourRanOnce || contentOpen !== "reports") return;
    // Continuously poll for required elements and tour state
    let pollInterval = setInterval(() => {
      const titleExists = document.querySelector('.reports-title');
      const exportBtnExists = document.querySelector('.export-pdf-btn');
      const tourAlreadyRunning = isTourRunning || isIntroJsActive();
      if (titleExists && exportBtnExists && !tourAlreadyRunning) {
        setTourStage("main");
        setTourRanOnce(true);
      }
    }, 150);

    // Cleanup
    return () => clearInterval(pollInterval);
  }, [userPermissions, isTourRunning]);

  // Manual tour trigger
  function handleManualTour() {
    if (isTourRunning || isIntroJsActive()) return;
    setTourStage("main");
    setManualTour(true);
  }

  return (
    <React.Fragment>
      <div id="report-content">
        <div className="card col-12 col-md-10 offset-0 offset-md-1 mt-5">
          <div className="card-header d-flex justify-content-between align-items-center">
            <div className="card-body col-12 col-md-10">
              <div className="mb-4">
                <div className="d-flex flex-wrap justify-content-between align-items-center no-print">
                  {/* Left-aligned Header */}
                  <h3>
                    <span
                      className="reports-title"
                      data-intro="Step 1: View Organization Reports"
                      data-step="1"
                    >
                      <i className="bi bi-file-text pe-3"></i>
                      Organization Reports
                      <i
                        className="bi bi-question-circle no-print d-none d-md-inline"
                        style={{
                          fontSize: '1.5rem',
                          cursor: 'pointer',
                          color: '#4d59df',
                          marginRight: '0.75rem',
                          marginLeft: '0.25rem'
                        }}
                        onClick={handleManualTour}
                      />
                    </span>
                  </h3>

                  {/* Right-aligned Button and Selector Group */}
                  <div className="d-flex flex-wrap mt-3 gap-3 align-items-center">
                    {LoadingPDF === true && (
                      <Button
                        variant="gray"
                        className="text-nowrap export-pdf-btn"
                        style={{ minWidth: '197.65px' }}
                        disabled
                      >
                        Loading...
                      </Button>
                    )}

                            {/*LoadingPDF === false && (
                                <Button
                                    variant="primary"
                                    className="text-nowrap export-pdf-btn"
                                    style={{ minWidth: '197.65px' }}
                                    onClick={async () => {
                                        try {
                                            setLoadingPDF(true);
                                            const response = await fetch(`${url}/api/foodPantry/reports/export-report-pdf`, {
                                                method: 'POST',
                                                headers: { 'Content-Type': 'application/json' },
                                                credentials: 'include',
                                                body: JSON.stringify({
                                                    orgID: selectedOrgID,
                                                    orgName: selectedOrg,
                                                    startDate,
                                                    endDate,
                                                }),
                                            });

                                            if (!response.ok) {
                                                // aaahhh it bad aaah
                                                return;
                                            }

                                            const blob = await response.blob();
                                            const disposition = response.headers.get('Content-Disposition');
                                            let filename = 'report.pdf';

                                            if (disposition && disposition.includes('filename=')) {
                                                filename = disposition.split('filename=')[1].replace(/"/g, '');
                                            }

                                            const link = document.createElement('a');
                                            link.href = window.URL.createObjectURL(blob);
                                            link.download = filename;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);

                                        } catch (err) {
                                            alert('Error exporting PDF: ' + err.message);
                                        } finally {
                                            setLoadingPDF(false);
                                        }
                                    }}
                                >
                                    Export Inventory PDF
                                </Button>)*/}
                                

                        <Button
                            variant="primary"
                            className="text-nowrap export-pdf-btn"
                            style={{ minWidth: '197.65px' }}
                            onClick={async () => {
                                setShowExportTransactionsModal(true)
                            }}
                        >
                            Export Transactions
                        </Button>
                    {showOrgSelector && (
                      <select
                        id="organization-select"
                        className="form-select no-print"
                        style={{ width: '250px' }}
                        value={selectedOrg}
                        onChange={handleOrgChange}
                        required
                      >
                        <option value="" disabled>Select Organization</option>
                        <option value="Sample Reports Page">Sample Reports Page</option>
                        {organization && organization.length > 0 && organization.map((org, index) => (
                          <option key={index} value={org.name || ''}>
                            {org.name || 'Unknown Organization'}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-12'>
                <div className="d-flex custom-print-row align-items-center justify-content-center mb-3 mt-4 only-print">
                  {/* needs to print org once I get the orgID fetching working */}
                  {/* <span className="fw-bold custom-print-meta only-print"> {selectedOrg} </span> */}
                  <div className="d-flex custom-print-meta align-items-center only-print custom-print-logo-group mx-auto">
                    <img
                      src="./images/BridgingHopeNoWord.svg"
                      alt="Bridging Hope Logo"
                      className="me-2 only-print"
                      style={{ width: "50px", height: "50px" }}
                    />
                    <h3 className="fw-bold only-print">Bridging Hope</h3>
                  </div>
                </div>
                <div className="d-flex custom-print-row align-items-center justify-content-between mb-3 only-print">
                  <div className="d-flex custom-print-meta align-items-center">
                    {/* Rearrange the date variables to be M/D/YYYY without 0 padding */}
                    <span className="fw-bold only-print"> Date Range: {startDate.split('-').slice(1, 3).map(p => p.replace(/^0/, '')).join('/')}/{startDate.split('-')[0]} – {endDate.split('-').slice(1, 3).map(p => p.replace(/^0/, '')).join('/')}/{endDate.split('-')[0]}</span>
                  </div>
                  <div className="d-flex custom-print-meta align-items-center">
                    <span className="fw-bold only-print"> Generated On: {new Date().toLocaleString()}</span>
                  </div>
                </div>
                <div className="d-flex flex-row align-items-center justify-content-between">
                </div>
                <div
                  className="d-flex flex-row"
                  style={{
                    gap: "20px",
                    width: "100%",
                  }}
                >
                </div>
              </div>
              <div className='row pt-3'>
                {/* Column 1: Top 10 Items by Quantity */}
                <div className='col-12 col-lg-4'>
                  <h5 className='pt-2 pb-3 text-center'>High Stock Items</h5>
                  <div className='text-dark'>
                    <DataTable
                      columns={stockColumns}
                      data={topQOHItems}
                      options={{
                        paging: false,
                        pageLength: 10,
                        searching: false,
                        ordering: false,
                        order: [[1, 'desc']],
                        responsive: true,
                        dom: 'frtp',
                        language: {
                          info: "_START_-_END_ of _TOTAL_ items",
                          infoEmpty: "No data available",
                          infoFiltered: "(filtered from _MAX_ total items)",
                        },
                      }}
                    />
                  </div>
                </div>

                {/* Column 2: Low Stock Items */}
                <div className='col-12 col-lg-4'>
                  <h5 className='pt-2 pb-3 text-center'>Low Stock Items</h5>
                  <div className='text-dark'>
                    <DataTable
                      columns={lowStockColumns}
                      data={lowStockItems}
                      options={{
                        paging: false,
                        pageLength: 10,
                        searching: false,
                        ordering: false,
                        order: [[2, 'asc']],
                        responsive: true,
                        dom: 'frtp',
                        language: {
                          info: "_START_-_END_ of _TOTAL_ items",
                          infoEmpty: "No data available",
                          infoFiltered: "(filtered from _MAX_ total items)",
                        },
                      }}
                    />
                  </div>
                </div>

                {/* Column 3: Out of Stock Items */}
                <div className='col-12 col-lg-4'>
                  <h5 className='pt-2 pb-3 text-center'>Out of Stock Items</h5>
                  <div className='text-dark'>
                    <DataTable
                      columns={outOfStockColumns}
                      data={outOfStockItems}
                      options={{
                        paging: false,
                        pageLength: 10,
                        searching: false,
                        scrollY: '800px',
                        scrollCollapse: true,
                        ordering: false,
                        order: [[2, 'desc']],
                        responsive: true,
                        dom: 'frtp',
                        language: {
                          info: "_START_-_END_ of _TOTAL_ items",
                          infoEmpty: "No data available",
                          infoFiltered: "(filtered from _MAX_ total items)",
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col-12'>
                <h5 className='pt-4 pb-3 d-flex flex-wrap justify-content-between align-items-center'>
                  {/* LEFT-ALIGNED TEXT CONTAINER */}
                  <div>
                    Top 10 Distributed Items{' '}
                    <span className="opacity-50 fs-6">
                      ({startDate.replace(/-/g, '/')} – {endDate.replace(/-/g, '/')})
                    </span>
                  </div>



                  {/* RIGHT-ALIGNED DATE INPUTS CONTAINER */}
                  {/* The d-flex align-items-center and style={{ gap: "10px" }} is already good for inline */}
                  <div className="d-flex flex-wrap gap-1 no-print align-items-center">
                    <div className="mt-2">
                      <span className="date-range-label">From</span>
                      <input
                        type="date"
                        className="date-range-input ms-2"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                    <div className="mt-2">
                        <span className="date-range-label ps-1">To</span>
                        <input
                        type="date"
                        className="date-range-input ms-2"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                  </div>
                </h5>

                <div className='text-dark'>
                  <DataTable
                    columns={popularItemsColumns}
                    data={topTenPopularItems}
                    options={{
                      paging: false,
                      pageLength: 10,
                      searching: false,
                      ordering: false,
                      order: [[1, 'desc']], // Sort by Units Distributed descending
                      responsive: true,
                      dom: 'frtp',
                      language: {
                        info: "_START_-_END_ of _TOTAL_ items",
                        infoEmpty: "No data available",
                        infoFiltered: "(filtered from _MAX_ total items)",
                      },
                    }}
                  />
                </div>
                <div className="d-flex justify-content-center" style={{ gap: "20px", padding: "20px 0" }} >
                  <StatCard
                    title="Total Items Distributed"
                    value={`${totalUnitsDistributed} items`}
                    className="col-6 bg-light border rounded p-3"
                  />

                  <StatCard
                    title="Total Value Distributed"
                    value={`$${totalDistributedValue}`}
                    className="col-6 bg-light border rounded p-3"
                  />
                </div>
                {/* Charts Section: Line chart and Pie chart side by side */}
                <span className='print-page-break' />
                {/* <div className=" d-flex flex-row justify-content-between align-items-stretch" style={{ width: "100%", gap: "24px", marginBottom: "0px" }}> */}
                <div className="d-flex flex-column flex-md-row justify-content-center d-print-block print-container" style={{ gap: "20px" }}>
                  {/* Three-way Apex line chart */}
                  <ChartCard className="w-100 p-print-0 chart-item print-full-width" style={{ maxWidth: "600px" }}>
                    <h5 className="mb-3 text-dark text-center no-print">Distribution Trends</h5>
                    {(dailyDistributedQuantity.length > 0 && dailyDistributedValue.length > 0) ? (
                      <ApexCharts
                        options={{
                          chart: {
                            id: "distribution-trends-line",
                            type: "line",
                            toolbar: {
                              tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false,
                              }
                            }
                          },
                          xaxis: {
                            categories: dailyDistributedQuantity.map(d => formatDate(d.date)),
                            title: { text: "Date" }
                          },
                          title: { text: "Total Units & Value Distributed", align: "center" },
                          colors: ["#60a5fa", "#e24800"],
                          stroke: { width: 2 },
                          legend: { position: "top" },
                          yaxis: [
                            { title: { text: "Units Distributed" } },
                            { title: { text: "Value Distributed ($)" }, opposite: true }
                          ],
                          tooltip: {
                            shared: true,
                            y: [
                              { formatter: val => `${val} units` },
                              { formatter: val => `$${val}` }
                            ]
                          }
                        }}
                        series={[
                          {
                            name: "Units Distributed",
                            data: dailyDistributedQuantity.map(d => Number(d.total_quantity))
                          },
                          {
                            name: "Value Distributed",
                            data: dailyDistributedValue.map(d => Number(d.daily_distributed_value))
                          }
                        ]}
                        type="line"
                        height={300}
                      />
                    ) : (
                      <p className="text-center">No Data Available.</p>
                    )}
                  </ChartCard>

                  {/* Pie chart */}
                  <ChartCard className="w-100 p-print-0 chart-item print-full-width" style={{ maxWidth: "600px" }}>
                    <h5 className="mb-3 text-dark text-center no-print">Category Breakdown</h5>
                    {categoryQOH.length > 0 ? (
                      <ApexCharts
                        options={{
                          chart: {
                            id: "category-pie", type: "pie", toolbar: {
                              tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false,
                              }
                            }
                          },
                          labels: categoryQOH.map(item => item.category),
                          title: { text: "Distribution by Category", align: "left" },
                          colors: ["#60a5fa", "#e24800", "#34d399", "#fbbf24", "#a78bfa", "#f472b6"],
                          legend: { position: "bottom" },
                        }}
                        series={categoryQOH.map(item => Number(item.percentage))}
                        type="pie"
                        height={300}
                      />
                    ) : (
                      <p className="text-center">No Data Available.</p>
                    )}
                  </ChartCard>

                  {/* Hidden table used ONLY for DataTables for transaction reports export */}
                  <table id="transactions" className="d-none">
                    <thead>
                      <tr>
                        <th>Inventory ID</th>
                        <th>Transaction Date</th>
                        <th>Type</th>
                        <th>Mode</th>
                        <th>Quantity</th>
                        <th>Unit Value</th>
                        <th>Line Value</th>
                        <th>Item Variation ID</th>
                        <th>Item ID</th>
                        <th>Item Name</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <ExportTransactionsModal
        show={showExportTransactionsModal}
        onHide={() => setShowExportTransactionsModal(false)}
        selectedOrgID={selectedOrgID}
    />
    </React.Fragment >
  );
}

export default Reports;